module.exports = __webpack_public_path__ + "static/img/ysfabj_jcjg_icon.png";